import React from 'react';
export function Footer() {
  return <footer className="w-full" data-id="element-122">
      <div className="max-w-[1200px] mx-auto px-8 py-6" data-id="element-123"></div>
    </footer>;
}